<template>
<ReportViewVencimientoContratoJugadores :path="path" :excelPath="excelPath" :filterPath="filterPath" :filenamePrefix="filenamePrefix"/>
</template>

<script>
import ReportViewVencimientoContratoJugadores from './ReportViewVencimientoContratoJugadores'

export default {
  components: {
    ReportViewVencimientoContratoJugadores
  },

  data () {
    return {
      path: 'contratos/vencimientos/cuerpo-tecnico/list',
      filterPath: 'filters/cuerpo-tecnico/vencimientos',
      excelPath: 'contratos/vencimientos/cuerpo-tecnico/xls',
      filenamePrefix: 'vencimiento_contratos_cuerpo_tecnico'
    }
  }
}
</script>
